import { render, staticRenderFns } from "./VeStuHealthScoreDetail.vue?vue&type=template&id=313e1f94&scoped=true"
import script from "./VeStuHealthScoreDetail.vue?vue&type=script&lang=js"
export * from "./VeStuHealthScoreDetail.vue?vue&type=script&lang=js"
import style0 from "./VeStuHealthScoreDetail.vue?vue&type=style&index=0&id=313e1f94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313e1f94",
  null
  
)

export default component.exports